import React from 'react';
import WeatherRow from './WeatherRow';
function WeatherTable({weather}) {
    return (
           
        <table id="weather">
            <caption className='caption_text'>Weather Table </caption>   
            <thead>
                <tr>
                    <th className='type_box'>Description</th>
                    <th className='link_box'>Web Links</th>
                </tr>
            </thead>
            <tbody>
                {weather.map((wx, i) => <WeatherRow wx={wx} key={i} />)}
            </tbody>
        </table>
    );
}
export default WeatherTable;
